module.exports = __webpack_public_path__ + "img/a4a6214.svg";